/**
 * External dependencies
 */
import React from "react";
import classNames from "classnames";

/**
 * Internal dependencies
 */
import config from "../config";
const { blockClassName } = config || {};

const ResultsWrapper = ({ children }) => {
	const componentClass = classNames(
		`${blockClassName}__results`,
	);

	return <div className={componentClass}>{children}</div>;
};

export default ResultsWrapper;
